<template>
  <b-modal
    id="modalRateioValorContrato"
    ref="modalRateioValorContrato"
    size="lg"
    title="Rateio de valores para Omie"
    hide-footer
    @hide="limparCampos"
  >
    <b-row>
      <b-col cols="12">
        <div
          class="aviso-rateio"
        >
          <p>Atenção: o rateio é obrigatório para a integração com a Omie, é necessário ratear o valor total da proposta entre todas as empresas!</p>
        </div>
        <vue-good-table
          id="tabelaRateioValorContrato"
          ref="tableRateio"
          :columns="columns"
          :rows="rows"
          :group-options="{
            enabled: true,
            collapsable: true,
          }"
          class="mb-1"
        >
          <template
            slot="table-header-row"
            slot-scope="props"
          >
            <span v-if="props.column.field === 'nome'">
              {{ props.row.nome }}
            </span>
            <div v-else-if="props.column.field === 'subTotal'">
              <span
                style="font-size: 13.5px !important;margin-left: 0.6rem;display: flex;"
              >
                {{ props.row.subTotal | converteValor }}
                <div
                  v-if="props.row.diferencia "
                  v-b-tooltip.hover.top="'O rateio não atende as regras de validação! Verifique a informação.'"
                >
                  <i class="fa-solid fa-circle-exclamation ml-50 text-danger" />
                </div>
              </span>
            </div>
          </template>
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field === 'nome'">
              {{ props.row.nome }}
            </span>
            <span v-else>
              <dinheiro-input
                v-model="props.row.subTotal"
                :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
                @input="alterarRateio($event, props.row)"
              />
            </span>
          </template>
        </vue-good-table>
        <b-row>
          <b-col cols="4">
            <b-form-group
              label="Valor proposta"
              style="font-weight: bold"
            >
              <dinheiro-input
                v-model="propostaAtual.valorTotalPropostaAuditar"
                :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
                :disabled="true"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group
              label="Valor rateado"
              style="font-weight: bold"
            >
              <dinheiro-input
                v-model="valorRateado"
                :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
                :disabled="true"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="valorRateado !== propostaAtual.valorTotalPropostaAuditar"
            cols="4"
            style="margin-top: 2.5rem;"
          >
            <span class="text-danger">Diferença: {{ diferencia | converteValor }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button
              block
              variant="none"
              size="sm"
              class="btn-primary"
              style="margin-left: 0;"
              :disabled="vinculadoContratoOmieEmpresa"
              @click="salvarRateio"
            >Confirmar</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<style lang="scss">
.aviso-rateio {
  text-align: left;
  font-size: 13px;
  background-color: rgb(231, 231, 231) !important;
  padding: 0.5rem;
  margin-bottom: 1rem;
  color: rgb(255, 0, 0);
  font-weight: 500;
  p{
    margin:0
  }
}

#tabelaRateioValorContrato {
  #vgt-table {
    font-size: 14.5px;
  }
}

.tamanho-campo-valor {
  font-size: 2px;
}

.tamanho-campo-nome {
  font-size: 13.5px;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'RateioValorContrato',
  components: {
    VueGoodTable,
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
  },
  props: {
    justificativa: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      propostaAtual: {
      },
      valorRateado: 0,
      diferencia: 0,
      columns: [
        {
          label: 'Serviço(s)', field: 'nome', sortable: false, tdClass: 'tamanho-campo-nome',
        },
        {
          label: 'Valor rateio', field: 'subTotal', sortable: false, tdClass: 'tamanho-campo-valor', width: '162px',
        },
      ],
      rows: [],
      existente: false,
      aberto: false,
      expandido: false,
    }
  },
  computed: {
    ...mapGetters('proposta', ['proposta', 'getRateioEmpresasServicos', 'vinculadoContratoOmieEmpresa']),
  },
  created() {
    this.propostaAtual = this.proposta
    api.getRateioProposta(this.propostaAtual.id)
      .then(payload => {
        if (payload.data && payload.data.length > 0) {
          this.setRateioRow(payload.data)
        }
      })
  },
  updated() {
    if (this.$refs.tableRateio && this.aberto && !this.expandido) {
      this.expandido = true
      this.$refs.tableRateio.expandAll()
    }
  },
  methods: {
    ...mapActions('proposta', ['limparRateio', 'updateRateioRow', 'setRateioRow']),
    getId() {
      return Math.random().toString(36).substring(2)
        + (new Date()).getTime().toString(36)
    },
    showModal() {
      this.propostaAtual = this.proposta
      api.getRateioProposta(this.propostaAtual.id)
        .then(payload => {
          if (payload.data && payload.data.length > 0) {
            this.rows = payload.data
            this.valorRateado = this.rows.reduce((acc, cur) => acc + cur.children.reduce((acc2, cur2) => acc2 + cur2.subTotal, 0), 0)
            this.setRateioRow(this.rows)
            this.existente = true
          } else if (!this.rows || this.rows.length === 0) {
            this.rows = this.getRateioEmpresasServicos
            this.diferencia = this.propostaAtual.valorTotalPropostaAuditar
            this.existente = false
          }
          this.aberto = true
          this.$refs.modalRateioValorContrato.show()
        })
    },
    salvarRateio() {
      this.linhas = this.rows.filter(filter => filter.subTotal !== 0 && filter.subTotal !== null)
      if (this.linhas.some(som => som.children.some(so => so.subTotal === 0 || so.subTotal === null)) || this.diferencia !== 0 || !this.validoEmpresasValorRateio()) {
        this.$erro('O rateio não atende as regras de validação! Verifique a informação.')
      } else {
        this.$isLoading(true)
        this.rows[0].justificativa = this.justificativa
        api.salvarRateioValoresEmpresa(this.propostaAtual.id, this.rows, this.existente)
          .then(() => {
            this.$sucesso('Rateio realizado com sucesso!')
            this.setRateioRow(this.rows)
            this.existente = true
            this.$refs.modalRateioValorContrato.hide()
          })
          .catch(err => {
            this.$erro(err.response.data.message || err.message)
          })
          .finally(() => {
            this.$isLoading(false)
          })
      }
    },
    validoEmpresasValorRateio() {
      let valido = true
      this.rows.forEach(element => {
        if (element.subTotal === 0 && element.children.some(som => som.subTotal !== 0)) {
          valido = false
        } else if (element.subTotal !== 0 && element.children.reduce((acc, cur) => acc + cur.subTotal, 0) !== element.subTotal) {
          valido = false
        }
      })
      return valido
    },
    alterarRateio(valor, prop) {
      if (this.rows && this.rows[prop.vgt_id]) {
        const row = this.rows[prop.vgt_id].children.find(f => f.idEmpresa === prop.idEmpresa)
        row.subTotal = valor
        this.valorRateado = this.rows.reduce((acc, cur) => acc + cur.children.reduce((acc2, cur2) => acc2 + cur2.subTotal, 0), 0).toFixed(2)
        this.diferencia = Math.abs(this.propostaAtual.valorTotalPropostaAuditar - this.valorRateado)

        const header = this.rows[prop.vgt_id]
        const totalValorEmpresas = header.children.reduce((acc, cur) => acc + cur.subTotal, 0).toFixed(2)
        header.diferencia = totalValorEmpresas !== header.subTotal.toFixed(2) || (header.children.some(som => !som.subTotal || som.subTotal === 0) && header.subTotal !== 0)
      }
    },
    limparCampos() {
      this.aberto = false
      this.expandido = false
      this.rows = []
      if (!this.existente) {
        this.limparRateio()
      }
      this.diferencia = 0
      this.propostaAtual = {}
      this.valorRateado = 0
    },
    getSubtotalServico(value) {
      const total = (value.valorAuditar + this.pacotes[0].acrescimoPacote) - this.pacotes[0].descontoPacote
      return total
    },
  },
}
</script>
